export default {"src":"/_next/static/media/icon-aledade.6bd21c45.svg","height":76,"width":76};